import { dataEyeBright } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEyeBright = /*#__PURE__*/createIcon(dataEyeBright)
export default IconEyeBright
